const API_BASE_URL = 'https://sandbox.xoxolite.com/xoxo/api';

export default { API_BASE_URL };